export default {
  SET_STATE: 'subscriptions/SET_STATE',
  FETCH_SUBSCRIPTIONS: 'subscriptions/FETCH_SUBSCRIPTIONS',
  FETCH_SINGLE: 'subscriptions/FETCH_SINGLE',
}
